module.exports = __webpack_public_path__ + "img/menu-toggle.eeece80e.svg";